"use client"

export async function clearClientCaches() {
  if (typeof window === "undefined") {
    return
  }

  if (!("caches" in window)) {
    return
  }

  try {
    const cacheNames = await caches.keys()
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)))
  } catch {
    // ignore cache purge failures
  }
}
